import { Link } from "react-router-dom";
import { Check, Gift } from "lucide-react";
import { IfGifts } from "@/hooks/useGiftsEnabled";
import { INCLUDED, EXTENSION_TEXT, StoryComingSoon } from "@/components/PurchaseCard";

export function PriceSection({ onStart }) {
  return (
    <section id="price" className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-testid="price-section" aria-labelledby="price-heading">
      <div className="glass-card p-8 sm:p-12">
        <div className="text-center">
          <p className="eyebrow mb-3">The original keepsake</p>
          <h2 id="price-heading" className="font-serif text-5xl sm:text-6xl text-[#EDE6F7]" data-testid="price-amount">£9.99</h2>
          <p className="mt-3 text-xl text-[#B57BFF]" data-testid="price-terms">£9.99 one-off payment. No subscription.</p>
          <p className="mt-2 text-[#A49CB8]">Pay once — you'll never be charged again for what you've bought. Invited family reply free.</p>
        </div>
        <div className="gold-line my-8" />
        <p className="eyebrow mb-4">What's included</p>
        <ul className="grid sm:grid-cols-2 gap-x-8 gap-y-4" data-testid="price-included">
          {INCLUDED.map((t) => (
            <li key={t} className="flex gap-3 text-[#D2CBE0] leading-relaxed">
              <Check className="h-5 w-5 mt-1 shrink-0 text-[#B57BFF]" aria-hidden="true" />
              <span>{t}</span>
            </li>
          ))}
        </ul>
        <p className="mt-5 text-sm text-[#8C84A0]">You can use fewer than six spaces — 12 recordings is the full allowance, not a promise of 12 finished messages.</p>
        <div className="grid sm:grid-cols-2 gap-4 mt-8">
          <div className="rounded-xl border border-[rgba(139,44,255,0.35)] bg-[#1A1222] p-4" data-testid="price-extension">
            <p className="text-[#EDE6F7] font-semibold">Add six more people <span className="text-[#B57BFF]">+£4.99</span></p>
            <p className="text-sm text-[#B9B3C8] mt-1 leading-relaxed">{EXTENSION_TEXT} £14.98 in total with the original keepsake.</p>
          </div>
          <StoryComingSoon />
        </div>
        <div className="text-center mt-10">
          <button data-testid="price-start-btn" onClick={onStart} className="gold-btn h-16 px-10 rounded-full text-xl">
            Record your first memory
          </button>
          <p className="mt-4 text-sm text-[#A49CB8]">Secure payment by Stripe after you create your account.</p>
          <IfGifts><div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2" data-testid="price-gift-links">
            <Link to="/gift" className="inline-flex items-center gap-2 text-lg text-[#B57BFF] font-semibold underline underline-offset-4" data-testid="price-gift-link">
              <Gift className="h-5 w-5" aria-hidden="true" /> Give it as a gift
            </Link>
            <Link to="/redeem" className="text-lg text-[#C9C2D8] underline underline-offset-4" data-testid="price-redeem-link">Have a gift code?</Link>
          </div></IfGifts>
        </div>
      </div>
    </section>
  );
}
